import Route from "../../../router/Route";
import { RouterView, RouteLocationNormalized } from "vue-router";

import Overview from "../pages/Overview.vue";
import EditOverview from "../pages/Edit.vue";
import PermissionTab from "@/modules/roles/components/PermissionTab.vue";
import GeneralSettingsTab from "@/modules/roles/components/GeneralSettingsTab.vue";
import FavoriteDimensionsTab from "@/modules/roles/components/FavoriteDimensionsTab.vue";

export default new Route("roles", "/roles", RouterView, [
	new Route("roles.index", "", Overview, []),
	new Route(
		"roles.edit",
		"edit/:uuid",
		EditOverview,
		[
			new Route("roles.edit.permissions", "permissions", PermissionTab, []),
			new Route(
				"roles.edit.general",
				"general-settings",
				GeneralSettingsTab,
				[]
			),
			new Route(
				"roles.edit.favoriteDimensions",
				"favorite-dimensions",
				FavoriteDimensionsTab,
				[]
			),
		],
		{},
		(to: RouteLocationNormalized): string => {
			return `/roles/edit/${to.params.uuid}/permissions`;
		}
	),
]);
